// DS: C35
import React from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import { BiLoggerContextProvider } from '@wix/da-bi/pkg/BiLogger.context';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import PremiumGallery from '@wix/da-ds/pkg/Icons/24x24/PremiumGallery';
import EyeDisc2 from '@wix/da-ds/pkg/Icons/16x16/EyeDisc2';
import UserAvatar from '../../User/Avatar';
import SimpleTooltip from '@wix/da-ds/pkg/tooltips/dsPreset/SimpleTooltip';
import { normalizePremiumFolderData } from '../../utils/normalizePremiumFolderData';
import { getDeviationTitle } from '../../DeviationViews/_helpers';
import Author from '../_partials/Author';
import GroupDetail from '../_partials/GroupDetail';
import Title from '../_partials/Title';
import PublishedTime from '../_partials/PublishedTime';
import AdoptableOwner from '../_partials/AdoptableOwner';
import s from './DesktopSubmissionDetails.scss';
const DesktopSubmissionDetails = ({ className, deviation, deviation: { author, extended }, isOwner, showTitle })=>{
    var _deviation_extended;
    const { t } = useTranslation();
    const deviationTitle = getDeviationTitle(deviation);
    const isShowingTitle = deviationTitle && showTitle;
    const { isPremium, isPaidFolder } = normalizePremiumFolderData(deviation === null || deviation === void 0 ? void 0 : deviation.premiumFolderData);
    const premiumTooltip = isPaidFolder ? t('deviation.details.premiumFolder.tooltip') : t('deviation.details.watchersOnlyFolder.tooltip');
    const PremiumIcon = isPaidFolder ? PremiumGallery : EyeDisc2;
    const adoptable = (_deviation_extended = deviation.extended) === null || _deviation_extended === void 0 ? void 0 : _deviation_extended.adoptable;
    var _extended_exclusiveGroup, _extended_originalAuthor;
    return /*#__PURE__*/ React.createElement("div", {
        className: classnames(s['root'], !isShowingTitle && s['no-title'], className)
    }, /*#__PURE__*/ React.createElement(BiLoggerContextProvider, {
        value: {
            sectionname: 'author'
        }
    }, /*#__PURE__*/ React.createElement("div", {
        className: s['left']
    }, author && /*#__PURE__*/ React.createElement(UserAvatar, {
        withTooltip: true,
        relatedItemBiData: {
            typeid: deviation.typeId,
            itemid: deviation.deviationId
        },
        size: 50,
        user: (_extended_exclusiveGroup = extended === null || extended === void 0 ? void 0 : extended.exclusiveGroup) !== null && _extended_exclusiveGroup !== void 0 ? _extended_exclusiveGroup : author,
        className: s['avatar']
    })), /*#__PURE__*/ React.createElement("div", {
        className: s['middle']
    }, isShowingTitle && /*#__PURE__*/ React.createElement("div", {
        className: s['title-row']
    }, isPremium && /*#__PURE__*/ React.createElement(SimpleTooltip, {
        className: s['premium-icon'],
        text: premiumTooltip
    }, /*#__PURE__*/ React.createElement(PremiumIcon, {
        size: IconSize.SMALL
    })), /*#__PURE__*/ React.createElement(Title, {
        title: deviationTitle,
        showTitle: true,
        className: s['title']
    })), /*#__PURE__*/ React.createElement("div", {
        className: s['middle-lower']
    }, (extended === null || extended === void 0 ? void 0 : extended.exclusiveGroup) && /*#__PURE__*/ React.createElement(GroupDetail, {
        group: extended.exclusiveGroup,
        className: s['group']
    }), /*#__PURE__*/ React.createElement(Author, {
        author: (_extended_originalAuthor = extended === null || extended === void 0 ? void 0 : extended.originalAuthor) !== null && _extended_originalAuthor !== void 0 ? _extended_originalAuthor : author,
        isOwner: isOwner,
        className: s['original-author']
    }))), /*#__PURE__*/ React.createElement("div", {
        className: s['right']
    }, /*#__PURE__*/ React.createElement(PublishedTime, {
        className: s['published-time'],
        publishedTime: deviation.publishedTime
    }), adoptable && /*#__PURE__*/ React.createElement(AdoptableOwner, {
        className: s['adoptable-owner'],
        adoptable: adoptable
    }))));
};
DesktopSubmissionDetails.displayName = 'DesktopSubmissionDetails';
export default DesktopSubmissionDetails;
